// store.js
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import userAuthSlice from "./slices/auth";  // your auth slice
import ComponentStore from "./slices/component";  // your auth slice

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  auth: userAuthSlice,
  component:ComponentStore,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // 🔥 required to avoid warnings with redux-persist
    }),
});

export const persistor = persistStore(store);
